<h2 class="default-dialog-header" mat-dialog-title>
	<span fxFlex>Help us improve</span>
</h2>
<mat-divider></mat-divider>
<mat-dialog-content class="default-dialog-content">
	<div
		*ngIf="showAutomaticPromptQuestion()"
		class="m-t-2 m-b-1"
		fxLayout="row"
		fxLayoutAlign="center center"
		fxLayoutGap="2rem"
	>
		<div class="mt-3" fxFlex="45">Is the rate accurate?</div>
		<div fxFlex fxFlexOffset="1">
			<mat-radio-button
				(click)="submit({ feedbackData: priceFeedbackForm.value, feedbackType: 'spotOn' })"
				color="primary"
			>
				Spot On
			</mat-radio-button>
		</div>
		<div fxFlex fxFlexOffset="1">
			<mat-radio-button (click)="isPriceNotAccurate = true" color="primary"> No </mat-radio-button>
		</div>
	</div>
	<form *ngIf="!showAutomaticPromptQuestion()" [formGroup]="priceFeedbackForm">
		<div
			*ngIf="showRateType"
			class="m-t-2 m-b-1"
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="2rem"
		>
			<div fxFlex="50">Where did the rate fall?</div>
			<div fxFlex>
				<div class="full-width mat-form-field">
					<mat-radio-group formControlName="rateType">
						<mat-radio-button class="m-r-2" color="primary" value="high">High</mat-radio-button>
						<mat-radio-button class="m-r-2" color="primary" value="low">Low</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
		</div>

		<div class="m-t-2 m-b-1" fxLayout="row" fxLayoutAlign="center center" fxLayoutGap="2rem">
			<div fxFlex="50">Do you have a current rate?</div>
			<div fxFlex>
				<div class="full-width">
					<mat-radio-group formControlName="hasRate">
						<mat-radio-button class="m-r-2" color="primary" value="true">Yes</mat-radio-button>
						<mat-radio-button class="m-r-2" color="primary" value="false">No</mat-radio-button>
					</mat-radio-group>
				</div>
			</div>
		</div>

		<div
			*ngIf="priceFeedbackForm.get('hasRate').value === 'true'"
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="2rem"
		>
			<div fxFlex="50">What is it?</div>
			<div fxFlex>
				<mat-form-field class="full-width">
					<input formControlName="currentRate" matInput type="number" />
					<mat-icon class="primary-light-color" class="vertical-align-bottom .m-r-0-5" matPrefix
						>attach_money</mat-icon
					>
				</mat-form-field>
			</div>
		</div>

		<div
			*ngIf="priceFeedbackForm.get('hasRate').value === 'true'"
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="2rem"
		>
			<div fxFlex="50">Where is the rate from?</div>
			<div fxFlex>
				<mat-form-field class="full-width">
					<mat-select formControlName="rateSource" name="rateSource">
						<mat-option *ngFor="let source of rateSources" [value]="source">
							{{ source }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<div
			*ngIf="showRatingServiceInput()"
			fxLayout="row"
			fxLayoutAlign="center center"
			fxLayoutGap="2rem"
		>
			<div fxFlex="50">Rating Service</div>
			<div fxFlex>
				<mat-form-field class="full-width">
					<mat-select formControlName="ratingService" name="ratingService">
						<mat-option *ngFor="let service of ratingServices" [value]="service">
							{{ service }}
						</mat-option>
					</mat-select>
				</mat-form-field>
			</div>
		</div>

		<div class="m-b-1" fxLayoutAlign="end end" fxLayoutGap="1rem">
			<span (click)="closeDialog()" class="text-underline cursor-pointer">Cancel</span>
			<button
				(click)="submit({ feedbackData: priceFeedbackForm.value, feedbackType: 'notAccurate' })"
				[disabled]="priceFeedbackForm.invalid"
				color="primary"
				mat-raised-button
			>
				Submit
			</button>
		</div>
	</form>
</mat-dialog-content>
